/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    matchId: null,
    isLoading: false,
    players: [],
    name: null,
    password: null,
};
export const PlayersSlice = createSlice({
    name: 'players',
    initialState,
    reducers: {
        setPlayersMatchId: (state, action) => {
            state.matchId = action.payload;
        },
        setPlayers: (state, action) => {
            state.players = action.payload;
        },
        setPlayersLoading: (state, action) => {
            state.isLoading = action.payload;
        },
    },
});
export default PlayersSlice.reducer;
export const selectPlayersMatchId = (state) => state.players.matchId;
export const selectPlayersLoading = (state) => state.players.isLoading;
export const selectPlayers = (state) => state.players.players;
export const { setPlayersMatchId, setPlayers, setPlayersLoading } = PlayersSlice.actions;
